import {
    signInAnonymously,
    User
} from "@firebase/auth";
import {
    auth
} from "./domain";

export function anonymousSignin(): Promise < User > {
    return new Promise(function (resolve, reject) {
        auth.onAuthStateChanged(function (user) {
            if (!user) {
                signInAnonymously(auth).catch(function () {
                    alert("001: Error during authentication. Please try reloading the page.");
                    reject();
                });
            } else {
                resolve(user);
            }
        });

    });
}


export function getUrlParameter(sParam: string): string | null {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ?
                "" :
                decodeURIComponent(sParameterName[1]);
        }
    }
    return null;
}